// removed by extract-text-webpack-plugin
module.exports = {"SortableTableHeader":"_1pGFQReHOT"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SortableTableHeader/SortableTableHeader.scss
// module id = 903
// module chunks = 0